export default __webpack_public_path__ + "static/media/gallery-articles_00.e57c6c2a.jpg";